import React, { useCallback, useEffect } from 'react'
import TestCaseList from './testCases/list/TestCaseList'
import AddTestCaseDrawer from './testCases/forms/AddTestCaseDrawer'

import { useDispatch, useSelector } from 'react-redux'
import {
    setFilter,
    testCaseList,
    testCaseState,
} from '../../redux/testCases/testCaseList.slice'
import FilterDrawer from './testCases/list/filter/FilterDrawer'
import { getCurrentProjectId, isValidArray } from './testCases/forms/helper'
import './testReport.module.css'

const TestReportMain = (props) => {
    const { stateTestCase = {}, setStateTestCase = () => {} } = props

    const dispatch = useDispatch()
    const {
        pagination,
        searchValue = '',
        filter,
        defaultFilter,
    } = useSelector(testCaseState)
    const { pageSize = 10, currentPage = 0 } = pagination

    const projectId = getCurrentProjectId()

    const tagsArray = isValidArray(filter?.tags)
        ? filter?.tags?.map((item) => item?.value)
        : []
    const epic = isValidArray(filter?.epic)
        ? filter?.epic?.map((item) => item?.value)
        : []
    const sprint = filter?.sprint?.value || ''

    const handleTestCaseList = useCallback(
        (search = '') => {
            const payload = {
                skip: (currentPage - 1) * pageSize,
                limit: pageSize,
                filter: {
                    epic: epic || [],
                    sprint: sprint || '',
                    ...(isValidArray(filter?.tags)
                        ? {
                              tags: tagsArray,
                          }
                        : {}),
                    project: projectId,
                },
                search: {
                    title: searchValue,
                    testId: searchValue,
                },
                sort: 'createdAt',
                sortType: 'desc',
            }
            dispatch(testCaseList(payload))
        },
        [dispatch, currentPage, pageSize, searchValue, filter]
    )

    useEffect(() => {
        handleTestCaseList()
    }, [handleTestCaseList])

    useEffect(() => {
        return () => {
            dispatch(setFilter(defaultFilter))
        }
    }, [])

    return (
        <div>
            <TestCaseList
                stateTestCase={stateTestCase}
                setStateTestCase={setStateTestCase}
            />

            <AddTestCaseDrawer
                stateTestCase={stateTestCase}
                setStateTestCase={setStateTestCase}
                handleTestCaseList={handleTestCaseList}
            />

            <FilterDrawer
                stateTestCase={stateTestCase}
                setStateTestCase={setStateTestCase}
                handleTestCaseList={handleTestCaseList}
            />
        </div>
    )
}

export default TestReportMain
